<template>
    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" @click.self="close">
            <Transition name="modal-slide">
                <div v-if="isdisplay" class="cf-dialog cf-dialog--xxl">

                    <!-- ========== HEADER ========== -->
                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon"><i class="ri-printer-line"></i></span>
                            <div>
                                <h4 class="cf-dialog-title">Imprimer les fiches techniques</h4>
                                <p class="cf-modal-head__sub">Choisissez le modèle, l'entrepôt et les articles à imprimer</p>
                            </div>
                        </div>
                        <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                    </div>

                    <!-- ========== TOOLBAR ========== -->
                    <div class="cf-dialog-toolbar">
                        <div class="cf-toolbar-row">
                            <div class="pf-field">
                                <label>Modèle</label>
                                <select v-model="modele" class="cf-inp cf-select">
                                    <option value="cuisine">Fiche cuisine (sans prix)</option>
                                    <option value="cout">Fiche de coût</option>
                                </select>
                            </div>
                            <div class="pf-field pf-field--grow">
                                <label>Entrepôt</label>
                                <select v-model="pidmag" @change="load" class="cf-inp cf-select">
                                    <option value="">Tous les entrepôts</option>
                                    <option v-for="(magasin,index) of listemagasins" :key="index" :value="magasin.pid">{{ magasin.name }}</option>
                                </select>
                            </div>
                            <div class="pf-field">
                                <label>Disposition</label>
                                <select v-model="disposition" class="cf-inp cf-select">
                                    <option value="continu">En continu</option>
                                    <option value="page">Une fiche par page</option>
                                </select>
                            </div>
                            <button @click="exporterExcel" :disabled="!selection.length" type="button" class="ti-btn ti-btn-light pf-btn">
                                <i class="ri-file-excel-2-line"></i> Excel
                            </button>
                            <button @click="imprimer" :disabled="!selection.length" type="button" class="ti-btn ti-btn-primary-full pf-btn">
                                <i class="ri-printer-line"></i> Imprimer
                            </button>
                        </div>
                    </div>

                    <!-- ========== BODY ========== -->
                    <div class="pf-body">

                        <!-- Sélection des articles -->
                        <div class="pf-side">
                            <div class="search-wrap">
                                <i class="ri-search-line search-icon"></i>
                                <input v-model="searchword" type="search" class="search-input" placeholder="Rechercher un article...">
                            </div>
                            <div class="pf-side-actions">
                                <button @click="toutCocher(true)" type="button" class="pf-link">Tout cocher</button>
                                <button @click="toutCocher(false)" type="button" class="pf-link">Tout décocher</button>
                                <span class="pf-count"><b>{{ selection.length }}</b> / {{ articles.length }}</span>
                            </div>
                            <div class="pf-list">
                                <template v-if="articlesFiltres.length">
                                    <label class="pf-item" v-for="article in articlesFiltres" :key="article.pid">
                                        <input type="checkbox" v-model="coches[article.pid]">
                                        <span class="pf-item__name">{{ article.libelle }}</span>
                                        <span class="pf-item__nb">{{ article.lignes.length }}</span>
                                    </label>
                                </template>
                                <p v-else class="pf-empty">Aucun article.</p>
                            </div>
                        </div>

                        <!-- Aperçu -->
                        <div class="pf-preview">
                            <div v-if="loading" class="animate-pulse cf-skeleton">
                                <div class="cf-skeleton-bar"></div>
                                <div class="cf-skeleton-bar"></div>
                                <div class="cf-skeleton-bar"></div>
                            </div>
                            <div v-else-if="!selection.length" class="empty-state">
                                <div class="empty-state__icon"><i class="ri-inbox-line"></i></div>
                                <p class="empty-state__title">Aucune fiche sélectionnée.</p>
                                <p class="empty-state__sub">Cochez au moins un article dans la liste.</p>
                            </div>
                            <div v-else class="pf-sheet" v-html="documentHtml"></div>
                        </div>

                    </div>

                    <!-- ========== FOOTER ========== -->
                    <div class="cf-dialog-foot cf-dialog-foot--split">
                        <p class="cf-foot-info"><b>{{ selection.length }}</b> fiche(s) dans l'aperçu</p>
                        <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                    </div>

                    <!-- Table à plat pour l'export Excel (hors écran) -->
                    <table ref="exceltable" class="pf-excel">
                        <thead>
                        <tr>
                            <th>Article</th>
                            <th>Unité de vente</th>
                            <th>Matière première</th>
                            <th>Portion</th>
                            <th>Unité</th>
                            <template v-if="modele==='cout'">
                                <th>Prix d'achat</th>
                                <th>Coût</th>
                                <th>Coût matière de l'article</th>
                                <th>Prix de vente</th>
                                <th>Marge</th>
                                <th>Part du coût (%)</th>
                            </template>
                        </tr>
                        </thead>
                        <tbody>
                        <template v-for="article in selection" :key="article.pid">
                            <tr v-for="ligne in article.lignes" :key="article.pid+ligne.pid">
                                <td>{{ article.libelle }}</td>
                                <td>{{ article.unite }}</td>
                                <td>{{ ligne.libelle }}</td>
                                <td>{{ ligne.qte }}</td>
                                <td>{{ ligne.unite }}</td>
                                <template v-if="modele==='cout'">
                                    <td>{{ ligne.pa }}</td>
                                    <td>{{ ligne.cout }}</td>
                                    <td>{{ article.cout }}</td>
                                    <td>{{ article.pv }}</td>
                                    <td>{{ article.pv>0 ? article.marge : '' }}</td>
                                    <td>{{ article.pv>0 ? article.part : '' }}</td>
                                </template>
                            </tr>
                        </template>
                        </tbody>
                    </table>

                </div>
            </Transition>
        </div>
    </Transition>
</template>

<script>
    import {mapGetters} from "vuex";
    import {currentDateTime, ExportExcel, randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
    const axios =require('axios');

    // Feuille de style du document : sert à l'aperçu ET à la fenêtre d'impression.
    // Noir et gris uniquement, pour rester lisible sur une imprimante noir et blanc.
    const CSS_DOCUMENT = `
.ftp-doc{font-family:Arial,Helvetica,sans-serif;font-size:12px;color:#111;line-height:1.35}
.ftp-doc *{box-sizing:border-box}
.ftp-head{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:2px solid #111;padding-bottom:8px;margin-bottom:14px}
.ftp-head p{margin:0}
.ftp-head .ftp-h1{font-size:15px;font-weight:bold}
.ftp-head .ftp-h2{font-size:11px;color:#444}
.ftp-right{text-align:right}
.ftp-fiche{border:1px solid #666;margin-bottom:14px;break-inside:avoid;page-break-inside:avoid}
.ftp-fiche-head{display:flex;justify-content:space-between;align-items:center;gap:12px;padding:7px 10px;background:#eee;border-bottom:1px solid #666}
.ftp-fiche-head p{margin:0}
.ftp-nom{font-size:13px;font-weight:bold}
.ftp-sub{font-size:11px;color:#444;white-space:nowrap}
.ftp-doc table{width:100%;border-collapse:collapse}
.ftp-doc th{text-align:left;font-size:11px;font-weight:bold;color:#333;padding:4px 10px;border-bottom:1px solid #666}
.ftp-doc td{padding:4px 10px;border-bottom:1px solid #ccc}
.ftp-doc .r{text-align:right}
.ftp-synth{display:flex;border-top:1px solid #666}
.ftp-synth div{flex:1;padding:6px 10px;border-right:1px solid #ccc}
.ftp-synth div:last-child{border-right:none}
.ftp-synth span{display:block;font-size:10px;color:#444}
.ftp-synth b{font-size:13px}
.ftp-note{font-size:10px;color:#444;padding:4px 10px;border-top:1px solid #ccc}
.ftp-recap-titre{font-size:13px;font-weight:bold;margin:18px 0 6px}
.ftp-recap{border:1px solid #666}
.ftp-recap tfoot td{font-weight:bold;border-top:1px solid #666;border-bottom:none}
.ftp-page .ftp-fiche{break-after:page;page-break-after:always}
.ftp-page .ftp-recap-bloc{break-before:page;page-break-before:always}
`;

    export default {
        /* eslint-disable */
        name: "modalprintfichetechniquev2",

        computed:{
            ...mapGetters(['listeotherdatacentredeconsommation_paramcom_magasin']),

            listemagasins(){
                let data=this.listeotherdatacentredeconsommation_paramcom_magasin;
                return data && Array.isArray(data.magasin)?data.magasin:[];
            },

            nomEntrepot(){
                let t=this;
                if (this.pidmag==="") return "Tous les entrepôts";
                let magasin=this.listemagasins.find(function (item) { return item.pid===t.pidmag });
                return magasin?magasin.name:"";
            },

            nomSociete(){
                return this.$store.state.etatraisonsocial || this.$store.state.appsociete || "";
            },

            articlesFiltres(){
                let mot=this.searchword.toLowerCase();
                if (mot==='') return this.articles;
                return this.articles.filter(function (article) {
                    return article.libelle.toLowerCase().includes(mot)
                });
            },

            selection(){
                let t=this;
                return this.articles.filter(function (article) {
                    return t.coches[article.pid]===true
                });
            },

            documentHtml(){
                return '<style>'+CSS_DOCUMENT+'</style>'+this.construireDocument();
            },
        },

        data() {
            return {
                isdisplay:false,
                loading:false,
                modele:'cuisine',
                disposition:'continu',
                pidmag:"",
                searchword:"",
                articles:[],
                coches:{},
            };
        },

        methods: {

            echapper(value){
                return String(value===undefined || value===null?'':value)
                    .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
            },

            formatQte(value){
                let n=Number(value);
                if (isNaN(n)) return '0';
                return n.toLocaleString('fr-FR',{maximumFractionDigits:3});
            },

            formatMontant(value){
                let n=Number(value);
                if (isNaN(n)) return '0';
                return n.toLocaleString('fr-FR',{maximumFractionDigits:0});
            },

            formatPrix(value){
                let n=Number(value);
                if (isNaN(n)) return '0';
                return n.toLocaleString('fr-FR',{maximumFractionDigits:2});
            },

            dateEdition(){
                let d=new Date();
                return ('0'+d.getDate()).slice(-2)+'/'+('0'+(d.getMonth()+1)).slice(-2)+'/'+d.getFullYear();
            },

            toutCocher(valeur){
                let coches=Object.assign({},this.coches);
                for (let article of this.articlesFiltres){
                    coches[article.pid]=valeur;
                }
                this.coches=coches;
            },

            construireFiche(article){

                let t=this,cout=this.modele==='cout';

                let entete='<tr><th style="width:7%">N°</th><th>Matière première</th><th class="r" style="width:13%">Portion</th><th style="width:16%">Unité</th>'
                    +(cout?'<th class="r" style="width:15%">Prix d\'achat</th><th class="r" style="width:15%">Coût</th>':'')+'</tr>';

                let lignes=article.lignes.map(function (ligne,index) {
                    return '<tr><td>'+(index+1)+'</td><td>'+t.echapper(ligne.libelle)+'</td>'
                        +'<td class="r">'+t.formatQte(ligne.qte)+'</td><td>'+t.echapper(ligne.unite)+'</td>'
                        +(cout?'<td class="r">'+(ligne.pa>0?t.formatPrix(ligne.pa):'-')+'</td><td class="r">'+t.formatMontant(ligne.cout)+'</td>':'')
                        +'</tr>';
                }).join('');

                let synthese='';

                if (cout){
                    synthese='<div class="ftp-synth">'
                        +'<div><span>Coût matière</span><b>'+this.formatMontant(article.cout)+'</b></div>'
                        +'<div><span>Prix de vente</span><b>'+(article.pv>0?this.formatMontant(article.pv):'-')+'</b></div>'
                        +'<div><span>Part du coût</span><b>'+(article.pv>0?this.formatPrix(article.part)+' %':'-')+'</b></div>'
                        +'<div><span>Marge par vente</span><b>'+(article.pv>0?this.formatMontant(article.marge):'-')+'</b></div>'
                        +'</div>';

                    if (article.nbsansprix>0){
                        synthese+='<div class="ftp-note">'+article.nbsansprix+' matière(s) sans prix d\'achat : le coût matière est incomplet.</div>';
                    }
                }

                return '<div class="ftp-fiche">'
                    +'<div class="ftp-fiche-head"><p class="ftp-nom">'+this.echapper(article.libelle)+'</p>'
                    +'<p class="ftp-sub">Pour 1 '+this.echapper(article.unite)+' vendu(e) · '+article.lignes.length+' matière(s)</p></div>'
                    +'<table><thead>'+entete+'</thead><tbody>'+lignes+'</tbody></table>'
                    +synthese
                    +'</div>';

            },

            construireRecap(){

                let t=this;

                let lignes=this.selection.map(function (article) {
                    return '<tr><td>'+t.echapper(article.libelle)+(article.nbsansprix>0?' (coût incomplet)':'')+'</td>'
                        +'<td class="r">'+article.lignes.length+'</td>'
                        +'<td class="r">'+t.formatMontant(article.cout)+'</td>'
                        +'<td class="r">'+(article.pv>0?t.formatMontant(article.pv):'-')+'</td>'
                        +'<td class="r">'+(article.pv>0?t.formatMontant(article.marge):'-')+'</td>'
                        +'<td class="r">'+(article.pv>0?t.formatPrix(article.part)+' %':'-')+'</td></tr>';
                }).join('');

                return '<div class="ftp-recap-bloc"><p class="ftp-recap-titre">Récapitulatif</p>'
                    +'<table class="ftp-recap"><thead><tr><th>Article</th><th class="r">Matières</th><th class="r">Coût matière</th>'
                    +'<th class="r">Prix de vente</th><th class="r">Marge</th><th class="r">Part du coût</th></tr></thead>'
                    +'<tbody>'+lignes+'</tbody>'
                    +'<tfoot><tr><td colspan="6">'+this.selection.length+' article(s)</td></tr></tfoot>'
                    +'</table></div>';

            },

            construireDocument(){

                let t=this,cout=this.modele==='cout';

                let titre=cout?'Fiches techniques : coûts de revient':'Fiches techniques';
                let sousTitre='Édité le '+this.dateEdition()+(cout?' · document interne':'');

                let entete='<div class="ftp-head">'
                    +'<div><p class="ftp-h1">'+this.echapper(this.nomSociete)+'</p><p class="ftp-h2">Entrepôt : '+this.echapper(this.nomEntrepot)+'</p></div>'
                    +'<div class="ftp-right"><p class="ftp-h1">'+titre+'</p><p class="ftp-h2">'+sousTitre+'</p></div>'
                    +'</div>';

                let fiches=this.selection.map(function (article) {
                    return t.construireFiche(article)
                }).join('');

                return '<div class="ftp-doc'+(this.disposition==='page'?' ftp-page':'')+'">'
                    +entete+fiches+(cout?this.construireRecap():'')
                    +'</div>';

            },

            imprimer(){

                if (!this.selection.length){
                    toastr['error']( "Cochez au moins un article.","<b></b>");
                    return;
                }

                let pied=this.modele==='cout'?'Fiches techniques · modèle coût':'Fiches techniques · modèle cuisine';

                let html='<html><head><meta charset="utf-8"><title>Fiches techniques</title><style>'
                    +'@page{size:A4;margin:14mm 12mm 16mm 12mm;'
                    +'@bottom-left{content:"'+pied+'";font-family:Arial,sans-serif;font-size:9px;color:#666}'
                    +'@bottom-right{content:"Page " counter(page) " / " counter(pages);font-family:Arial,sans-serif;font-size:9px;color:#666}}'
                    +'body{margin:0}'
                    +CSS_DOCUMENT
                    +'</style></head><body>'+this.construireDocument()+'</body></html>';

                let fenetre=window.open('','_blank');

                if (!fenetre){
                    toastr['error']( "Le navigateur a bloqué la fenêtre d'impression.","<b></b>");
                    return;
                }

                fenetre.document.write(html);
                fenetre.document.close();
                fenetre.focus();
                fenetre.print();

            },

            exporterExcel(){

                if (!this.selection.length){
                    toastr['error']( "Cochez au moins un article.","<b></b>");
                    return;
                }

                let name=(this.modele==='cout'?"FICHES TECHNIQUES COUTS":"FICHES TECHNIQUES")+"_"+currentDateTime();
                ExportExcel('xlsx',name,undefined,undefined,this.$refs.exceltable);

            },

            show(){

                this.modele='cuisine';
                this.disposition='continu';
                this.pidmag="";
                this.searchword="";
                this.articles=[];
                this.coches={};

                this.$store.dispatch('loadlisteotherdatacentredeconsommation_paramcom_magasin')

                this.isdisplay=true;

                this.load();

            },

            close(){
                this.isdisplay=false;
            },

            async load(){

                const t = this;
                this.loading=true;

                let url=process.env.VUE_APP_API_URL+'/egl745874pstock771714dfe/fichetechnique/catalogue/'+this.$store.state.appsociete+'/'+randomString();

                try {

                    let res=await axios.post(url,{pidmag:this.pidmag},{
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                    });

                    if (res.data.success){

                        let anciennes=t.coches,premier=t.articles.length===0,coches={};

                        t.articles=res.data.m.articles;

                        // premier chargement : tout est coché ; ensuite on garde la sélection
                        for (let article of t.articles){
                            coches[article.pid]=premier?true:anciennes[article.pid]===true;
                        }

                        t.coches=coches;

                    }else{
                        toastr['error']( res.data.message || "Chargement impossible.","<b></b>");
                    }

                }catch (error) {
                    toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.","<b>Erreur</b>")
                }

                this.loading=false;

            },

        },

    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { position:relative; width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; height:94vh; max-height:94vh; overflow:hidden; }
.cf-dialog--xxl { max-width:1280px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-toolbar { padding:0.75rem 1.25rem; border-bottom:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }
.cf-dialog-foot--split { justify-content:space-between; flex-wrap:wrap; }
.cf-foot-info { font-size:0.78rem; color:var(--cf-muted); margin:0; }

/* Toolbar */
.cf-toolbar-row { display:flex; gap:0.75rem; align-items:flex-end; flex-wrap:wrap; }
.pf-field { display:flex; flex-direction:column; gap:3px; min-width:180px; }
.pf-field label { font-size:0.72rem; color:var(--cf-muted); }
.pf-field--grow { flex:1; }
.cf-inp { width:100%; height:38px; padding:0 12px; border-radius:var(--cf-radius-sm); border:1px solid rgb(var(--input-border,203 213 225)); background:#fff; color:var(--cf-ink); font-size:0.82rem; outline:none; transition:border-color 0.2s, box-shadow 0.2s; }
.cf-inp:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); }
.cf-select { cursor:pointer; }
.pf-btn { height:38px; }

/* Corps : sélection + aperçu */
.pf-body { display:flex; flex:1; min-height:0; }
.pf-side { width:300px; flex-shrink:0; display:flex; flex-direction:column; border-right:1px solid var(--cf-border); padding:0.9rem; gap:0.6rem; min-height:0; }
.search-wrap { position:relative; }
.search-icon { position:absolute; left:12px; top:50%; transform:translateY(-50%); color:var(--cf-faint); }
.search-input { width:100%; padding:8px 12px 8px 34px; border:1px solid rgb(var(--input-border,203 213 225)); border-radius:var(--cf-radius-sm); font-size:0.82rem; color:var(--cf-ink); outline:none; }
.search-input:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); }
.pf-side-actions { display:flex; align-items:center; gap:0.75rem; font-size:0.76rem; }
.pf-link { background:none; border:none; padding:0; color:rgb(var(--primary)); cursor:pointer; font-size:0.76rem; }
.pf-link:hover { text-decoration:underline; }
.pf-count { margin-left:auto; color:var(--cf-muted); }
.pf-count b { color:var(--cf-ink-strong); }
.pf-list { flex:1; overflow-y:auto; border:1px solid var(--cf-border); border-radius:var(--cf-radius-sm); }
.pf-item { display:flex; align-items:center; gap:0.5rem; padding:0.45rem 0.6rem; font-size:0.8rem; color:var(--cf-ink); border-bottom:1px solid var(--cf-surface-alt); cursor:pointer; }
.pf-item:hover { background:var(--cf-surface); }
.pf-item input { accent-color:rgb(var(--primary)); width:15px; height:15px; flex-shrink:0; }
.pf-item__name { flex:1; min-width:0; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.pf-item__nb { font-size:0.7rem; color:var(--cf-muted); background:var(--cf-surface-alt); border-radius:999px; padding:1px 7px; }
.pf-empty { font-size:0.8rem; color:var(--cf-muted); text-align:center; padding:1rem; margin:0; }

.pf-preview { flex:1; min-width:0; overflow:auto; background:var(--cf-surface-alt); padding:1.25rem; }
.pf-sheet { background:#fff; max-width:820px; margin:0 auto; padding:28px 30px; border:1px solid var(--cf-border); box-shadow:var(--cf-shadow-md); }

/* Table Excel : présente dans le DOM, hors écran */
.pf-excel { position:absolute; left:-99999px; top:0; }

/* Skeleton / empty */
.cf-skeleton { padding:1rem; }
.cf-skeleton-bar { height:0.9rem; border-radius:4px; background:#fff; margin-bottom:0.9rem; }
.empty-state { padding:3rem 1.5rem; text-align:center; }
.empty-state__icon { font-size:40px; color:var(--cf-faint); margin-bottom:12px; }
.empty-state__title { font-size:0.95rem; font-weight:600; color:var(--cf-ink-strong); margin:0; }
.empty-state__sub { font-size:0.8rem; color:var(--cf-muted); margin:4px 0 0; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

@media (max-width:900px) { .pf-body { flex-direction:column; } .pf-side { width:100%; border-right:none; border-bottom:1px solid var(--cf-border); max-height:38vh; } }
</style>
